import React from 'react';
import ServicesSection from '../sections/ServicesSection';

export default function Services() {
  return (
    <div style={{ paddingTop: 72 }}>
      <ServicesSection />
    </div>
  );
}
